import React from 'react';
import { SearchableDropdown } from '@scholastic/volume-react';

import { SearchableDropdownValue } from '../../Home/Home.dataparser';

import './ReportYearDropdown.scss';

export interface ReportYearDropdownProps {
  availableDates: Array<SearchableDropdownValue>;
  onSelect: (value: SearchableDropdownValue) => void;
}

const ReportYearDropdown = ({ onSelect, availableDates }: ReportYearDropdownProps) => {
  return (
    <SearchableDropdown
      className="stats-counter-reports-dropdown"
      items={availableDates}
      onItemSelect={(selectedValue: SearchableDropdownValue) => {
        onSelect(selectedValue);
      }}
    />
  );
};

export default ReportYearDropdown;
